import type { SllCalloutEventProperties } from '../events'

import { trackAnalyticsEvent } from '../track'

// Coverage matches case-insensitively, so normalise or one market splits in two.
const normalise = (properties: SllCalloutEventProperties): SllCalloutEventProperties => ({
  ...properties,
  market_id: properties.market_id.toLowerCase()
})

// Virtualized explore rows remount on scroll, so each market counts once per explore visit.
const exploreImpressions = new Set<string>()

/** Call when the explore table unmounts, so the next visit counts its impressions again. */
export function resetSllExploreImpressions() {
  exploreImpressions.clear()
}

/** Impression: the badge rendered, giving the open rate below a denominator. */
export function trackSllCalloutViewed(properties: SllCalloutEventProperties) {
  const normalised = normalise(properties)
  if (normalised.source === 'market_explore') {
    const key = `${normalised.source}:${normalised.chain_id}:${normalised.market_id}`
    if (exploreImpressions.has(key)) return
    exploreImpressions.add(key)
  }
  trackAnalyticsEvent('sll_callout_viewed', normalised)
}

export function trackSllCalloutOpenChange(isOpen: boolean, properties: SllCalloutEventProperties) {
  if (!isOpen) return

  trackAnalyticsEvent('sll_callout_opened', normalise(properties))
}
